import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow */
import { createAction } from '../../interfaces';
import paymentService from '../../services/payments';
import * as definitions from '../../definitions';
import { redirectActionCreators as redirectActions } from './redirect';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var paymentActionCreators = {
  getUserPaymentSourcesRequest: function getUserPaymentSourcesRequest(userId) {
    return createAction(definitions.GET_PAYMENT_SOURCES_REQUEST, userId);
  },
  getUserPaymentSourcesSuccess: function getUserPaymentSourcesSuccess(paymentSources) {
    return createAction(definitions.GET_PAYMENT_SOURCES_SUCCESS, paymentSources);
  },
  getUserPaymentSourcesFail: function getUserPaymentSourcesFail(error) {
    return createAction(definitions.GET_PAYMENT_SOURCES_FAIL, error);
  },
  deleteUserPaymentSourceRequest: function deleteUserPaymentSourceRequest(userId, sourceId) {
    return createAction(definitions.DELETE_PAYMENT_SOURCE_REQUEST, {
      userId: userId,
      sourceId: sourceId
    });
  },
  deleteUserPaymentSourceSuccess: function deleteUserPaymentSourceSuccess(sourceDeleted) {
    return createAction(definitions.DELETE_PAYMENT_SOURCE_SUCCESS, sourceDeleted);
  },
  deleteUserPaymentSourceFail: function deleteUserPaymentSourceFail(error) {
    return createAction(definitions.DELETE_PAYMENT_SOURCE_FAIL, error);
  },
  createPaymentSourceRequest: function createPaymentSourceRequest(userId, source) {
    return createAction(definitions.CREATE_PAYMENT_SOURCE_REQUEST, {
      userId: userId,
      source: source
    });
  },
  createPaymentSourceSuccess: function createPaymentSourceSuccess(paymentSource) {
    return createAction(definitions.CREATE_PAYMENT_SOURCE_SUCCESS, paymentSource);
  },
  createPaymentSourceFail: function createPaymentSourceFail(error) {
    return createAction(definitions.CREATE_PAYMENT_SOURCE_FAIL, error);
  },
  clearPaymentErrors: function clearPaymentErrors() {
    return createAction(definitions.CLEAR_PAYMENT_ERRORS);
  },
  setPaymentInfo: function setPaymentInfo(info) {
    return createAction(definitions.SET_PAYMENT_INFO, info);
  },
  clearPaymentInfo: function clearPaymentInfo() {
    return createAction(definitions.CLEAR_PAYMENT_INFO);
  },
  clearPaymentData: function clearPaymentData() {
    return createAction(definitions.CLEAR_PAYMENT_DATA);
  },
  getOrderRequest: function getOrderRequest() {
    return createAction(definitions.GET_ORDER_REQUEST);
  },
  getOrderSuccess: function getOrderSuccess(order) {
    return createAction(definitions.GET_ORDER_SUCCESS, order);
  },
  getOrderFail: function getOrderFail(error) {
    return createAction(definitions.GET_ORDER_FAIL, error);
  },
  updateOrderRequest: function updateOrderRequest() {
    return createAction(definitions.UPDATE_ORDER_REQUEST);
  },
  updateOrderSuccess: function updateOrderSuccess() {
    return createAction(definitions.UPDATE_ORDER_SUCCESS);
  },
  updateOrderFail: function updateOrderFail(error) {
    return createAction(definitions.UPDATE_ORDER_FAIL, error);
  },
  createSubscriptionOrderRequest: function createSubscriptionOrderRequest() {
    return createAction(definitions.CREATE_SUBSCRIPTION_ORDER_REQUEST);
  },
  createSubscriptionOrderSuccess: function createSubscriptionOrderSuccess(order) {
    return createAction(definitions.CREATE_SUBSCRIPTION_ORDER_SUCCESS, order);
  },
  createSubscriptionOrderFail: function createSubscriptionOrderFail(error) {
    return createAction(definitions.CREATE_SUBSCRIPTION_ORDER_FAIL, error);
  },
  createSessionOrderRequest: function createSessionOrderRequest() {
    return createAction(definitions.CREATE_SESSION_ORDER_REQUEST);
  },
  createSessionOrderSuccess: function createSessionOrderSuccess(order) {
    return createAction(definitions.CREATE_SESSION_ORDER_SUCCESS, order);
  },
  createSessionOrderFail: function createSessionOrderFail(error) {
    return createAction(definitions.CREATE_SESSION_ORDER_FAIL, error);
  },
  initOrderPaymentRequest: function initOrderPaymentRequest() {
    return createAction(definitions.INIT_ORDER_PAYMENT_REQUEST);
  },
  initOrderPaymentSuccess: function initOrderPaymentSuccess(order) {
    return createAction(definitions.INIT_ORDER_PAYMENT_SUCCESS, order);
  },
  initOrderPaymentFail: function initOrderPaymentFail(error) {
    return createAction(definitions.INIT_ORDER_PAYMENT_FAIL, error);
  }
};
export var clearPaymentData = function clearPaymentData() {
  return function (dispatch) {
    var clearPaymentDataAction = paymentActionCreators.clearPaymentData;
    dispatch(clearPaymentDataAction());
  };
};
export var clearPaymentErrors = function clearPaymentErrors() {
  return function (dispatch) {
    var clearPaymentErrorsAction = paymentActionCreators.clearPaymentErrors;
    dispatch(clearPaymentErrorsAction());
  };
};
export var setPaymentInfo = function setPaymentInfo(info) {
  return function (dispatch) {
    var setPaymentInfoAction = paymentActionCreators.setPaymentInfo;
    dispatch(setPaymentInfoAction(info));
  };
};
export var clearPaymentInfo = function clearPaymentInfo() {
  return function (dispatch) {
    var clearPaymentInfoAction = paymentActionCreators.clearPaymentInfo;
    dispatch(clearPaymentInfoAction());
  };
};
export var getUserPaymentSources = function getUserPaymentSources(userId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var getUserPaymentSourcesRequest, getUserPaymentSourcesSuccess, getUserPaymentSourcesFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getUserPaymentSourcesRequest = paymentActionCreators.getUserPaymentSourcesRequest, getUserPaymentSourcesSuccess = paymentActionCreators.getUserPaymentSourcesSuccess, getUserPaymentSourcesFail = paymentActionCreators.getUserPaymentSourcesFail;
              dispatch(getUserPaymentSourcesRequest(userId));
              return _context.abrupt("return", paymentService.getPaymentSources(userId).then(function (paymentSources) {
                dispatch(getUserPaymentSourcesSuccess(paymentSources));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getUserPaymentSourcesFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var deleteUserPaymentSource = function deleteUserPaymentSource(userId, sourceId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var deleteUserPaymentSourceRequest, deleteUserPaymentSourceSuccess, deleteUserPaymentSourceFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              deleteUserPaymentSourceRequest = paymentActionCreators.deleteUserPaymentSourceRequest, deleteUserPaymentSourceSuccess = paymentActionCreators.deleteUserPaymentSourceSuccess, deleteUserPaymentSourceFail = paymentActionCreators.deleteUserPaymentSourceFail;
              dispatch(deleteUserPaymentSourceRequest(userId, sourceId));
              return _context2.abrupt("return", paymentService.deletePaymentSource(userId, sourceId).then(function (deleteResponse) {
                dispatch(deleteUserPaymentSourceSuccess(deleteResponse));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(deleteUserPaymentSourceFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getOrder = function getOrder(orderId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var getOrderRequest, getOrderSuccess, getOrderFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getOrderRequest = paymentActionCreators.getOrderRequest, getOrderSuccess = paymentActionCreators.getOrderSuccess, getOrderFail = paymentActionCreators.getOrderFail;
              dispatch(getOrderRequest());
              return _context3.abrupt("return", paymentService.getOrder(orderId).then(function (order) {
                dispatch(getOrderSuccess(order));
                return order;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getOrderFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var updateOrder = function updateOrder(orderId, dto) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var updateOrderRequest, updateOrderSuccess, updateOrderFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              updateOrderRequest = paymentActionCreators.updateOrderRequest, updateOrderSuccess = paymentActionCreators.updateOrderSuccess, updateOrderFail = paymentActionCreators.updateOrderFail;
              dispatch(updateOrderRequest());
              return _context4.abrupt("return", paymentService.updateOrder(orderId, dto).then(function () {
                dispatch(updateOrderSuccess());
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateOrderFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var createSubscriptionOrder = function createSubscriptionOrder(dto) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var createSubscriptionOrderRequest, createSubscriptionOrderSuccess, createSubscriptionOrderFail, planId, includedAssets, options;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              createSubscriptionOrderRequest = paymentActionCreators.createSubscriptionOrderRequest, createSubscriptionOrderSuccess = paymentActionCreators.createSubscriptionOrderSuccess, createSubscriptionOrderFail = paymentActionCreators.createSubscriptionOrderFail;
              planId = dto.planId, includedAssets = dto.includedAssets, options = dto.options;

              if (planId) {
                _context5.next = 4;
                break;
              }

              throw new Error('Something went wrong');

            case 4:
              dispatch(createSubscriptionOrderRequest());
              return _context5.abrupt("return", paymentService.createSubscriptionOrder(planId, {
                includedAssets: includedAssets
              }).then(function (order) {
                var _dto$options;

                var redirectTo = "/checkout/".concat(order.id);

                if ((_dto$options = dto.options) !== null && _dto$options !== void 0 && _dto$options.checkoutRedirect) {
                  redirectTo = "".concat(redirectTo, "?redirect=").concat(options.checkoutRedirect);
                }

                dispatch(createSubscriptionOrderSuccess(order));

                if (options !== null && options !== void 0 && options.shouldRedirect) {
                  dispatch(redirectActions.redirectTo(redirectTo));
                }

                return order;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createSubscriptionOrderFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var createSessionOrder = function createSessionOrder(dto, options) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var createSessionOrderRequest, createSessionOrderSuccess, createSessionOrderFail;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              createSessionOrderRequest = paymentActionCreators.createSessionOrderRequest, createSessionOrderSuccess = paymentActionCreators.createSessionOrderSuccess, createSessionOrderFail = paymentActionCreators.createSessionOrderFail;
              dispatch(createSessionOrderRequest());
              return _context6.abrupt("return", paymentService.createSessionOrder(dto).then(function (order) {
                dispatch(createSessionOrderSuccess(order));
                var redirectTo = "/checkout/".concat(order.id);

                if (options !== null && options !== void 0 && options.checkoutRedirect) {
                  redirectTo = "".concat(redirectTo, "?redirect=").concat(options.checkoutRedirect);
                }

                if (options !== null && options !== void 0 && options.shouldRedirect) {
                  dispatch(redirectActions.redirectTo(redirectTo));
                }

                return order;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createSessionOrderFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var initOrderPayment = function initOrderPayment(orderInit, stripeCardToken) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var initOrderPaymentRequest, initOrderPaymentSuccess, initOrderPaymentFail, request;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              initOrderPaymentRequest = paymentActionCreators.initOrderPaymentRequest, initOrderPaymentSuccess = paymentActionCreators.initOrderPaymentSuccess, initOrderPaymentFail = paymentActionCreators.initOrderPaymentFail;
              dispatch(initOrderPaymentRequest());
              request = orderInit.planId ? paymentService.initSubscriptionOrderPayment(orderInit.planId, orderInit.orderId, stripeCardToken) : paymentService.initSessionOrderPayment(orderInit.sessionId, orderInit.orderId, stripeCardToken);
              return _context7.abrupt("return", request.then(function (order) {
                dispatch(initOrderPaymentSuccess(order));
                return order;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(initOrderPaymentFail(message));
                handleErrorResponse(error, dispatch); // This throw is intentional. This error is handled where this action is used.

                // This throw is intentional. This error is handled where this action is used.
                throw new Error(message);
              }));

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};